import ToolStylus from './ToolStylus';
import Shortcut from '../utils/Shortcut';

class ToolStylusFrame extends ToolStylus {
  static toolName = 'Frame';
  static shortcut = new Shortcut('F');

  static action({ controller }) {
    controller.actionSetStylus(controller.currentFrameStylus);
  }
}

export default ToolStylusFrame;
